var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "chatbot-archive" } }, [
    _c(
      "div",
      { staticClass: "d-flex", staticStyle: { "background-color": "#ffffff" } },
      [
        _c(
          "div",
          { staticClass: "side-menubar-wrapper" },
          [_c("SideMenuBar")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "archives-panels" },
          [
            _c("ConversationList", {
              attrs: {
                items: _vm.items,
                "active-chat-id": _vm.activeChatId,
                "on-conversation-selected": _vm.onConversationSelected,
                filters: _vm.filters,
                loading: _vm.loading,
                "show-load-more": _vm.items.length < _vm.total,
                loadMore: _vm.loadMore,
                getAllVisitorId: _vm.getAllVisitorId,
                getConversationById: _vm.getConversationById,
              },
              on: {
                "on-filters-changed": function ($event) {
                  return _vm.onFiltersChanged($event)
                },
              },
            }),
            _vm._v(" "),
            _c("ConversationViewer", {
              attrs: {
                conversation: _vm.getSelectedConversation(),
                "skeleton-loading": _vm.loading,
              },
            }),
            _vm._v(" "),
            _c("ConversationDetail", {
              attrs: {
                conversation: _vm.getSelectedConversation(),
                loading: _vm.loading,
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }